import { FE_ENABLE_PRODUCT_TILE_OOS_ENHANCEMENTS_250410 } from "@faire/retailer-settings/FE_ENABLE_PRODUCT_TILE_OOS_ENHANCEMENTS_250410";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingEnableProductTileOosEnhancements = (): boolean =>
  useSetting(FE_ENABLE_PRODUCT_TILE_OOS_ENHANCEMENTS_250410);

export const useAssignSettingEnableProductTileOosEnhancements = () =>
  useAssignSetting(FE_ENABLE_PRODUCT_TILE_OOS_ENHANCEMENTS_250410);
